import instructionImg1 from "../../../images/inst1.png";
import instructionImg2 from "../../../images/inst2.png";
import instructionImg3 from "../../../images/inst3.png";
import instructionImgHi1 from "../../../images/insthi1.png";
import instructionImgHi2 from "../../../images/insthi2.png";
import instructionImgHi3 from "../../../images/insthi3.png";
import allenInstructionsEn from "../../../images/allenInstructionsEn.jpg"

const instructioncontentSsc = {
  en: `<img src="${allenInstructionsEn}"  alt="Instructions" />`,
  // en: `<img src="${instructionImg1}"  alt="Instructions" /></p><p><img src="${instructionImg2}"  alt="Instructions" /></p><p><img src="${instructionImg3}"  alt="Instructions" /></p>`,
  hi: `<img src="${instructionImgHi1}"  alt="Instructions" /></p><p><img src="${instructionImgHi2}"  alt="Instructions" /></p><p><img src="${instructionImgHi3}"  alt="Instructions" /></p>`,
};
export default instructioncontentSsc; 